<template>
  <table class="table">
    <thead>
      <tr>
        <th>Đường dẫn</th>
        <th>Thời gian chỉnh sửa</th>
        <th>Kích cỡ</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="disk in client_detail.client_detail?.disk" :key="disk">
        <tr>
          <td>
            <RouterLink
              :to="{
                name: 'ClientExplorer',
                query: {
                  ...$route.query,
                  path: disk.toUpperCase().endsWith(':') ? disk : disk + ':',
                },
              }"
              class="link"
            >
              <i class="fa-solid fa-hard-drive text-base-content/80 mr-1"></i>
              {{ disk.toUpperCase().endsWith(":") ? disk : disk + ":" }}
            </RouterLink>
          </td>
          <td></td>
          <td></td>
        </tr>
      </template>
    </tbody>
  </table>
</template>
<script setup lang="ts">
import { use_client_detail } from "../useClientDetail";

const client_detail = use_client_detail();
</script>
